import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

const useStyles = makeStyles(theme => ({
  button: {
    borderRadius: 3
  },
  selected: {
    color: 'white',
    backgroundColor: `${theme.palette.secondary.main} !important`
  },
  listIcon: {
    color: '#2e2e2e'
  },
  listIconSelected: {
    color: 'white'
  },
  visibilityOpen: {
    opacity: 1,
    transition: theme.transitions.create('opacity', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  visibilityClose: {
    opacity: 0,
    transition: theme.transitions.create('opacity', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  }
}));

interface ClickableNavigationItemProps {
  label: string;
  icon?: JSX.Element;
  selected?: boolean;
  open?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const ClickableNavigationItem = ({
  label,
  icon,
  selected,
  open,
  onClick
}: ClickableNavigationItemProps): JSX.Element => {
  const classes = useStyles();
  return (
    <ListItem
      button
      selected={selected}
      onClick={onClick}
      classes={{
        button: clsx({ [classes.button]: open }),
        selected: classes.selected
      }}
    >
      {icon && (
        <ListItemIcon className={clsx(classes.listIcon, { [classes.listIconSelected]: selected })}>
          {icon}
        </ListItemIcon>
      )}
      <ListItemText
        className={clsx({
          [classes.visibilityOpen]: open,
          [classes.visibilityClose]: !open
        })}
        primary={label}
      />
    </ListItem>
  );
};

export default ClickableNavigationItem;
